/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AggregierteAuswertungLayoutDto } from '../models/aggregierte-auswertung-layout-dto';
import { AggregierteAuswertungSpalteDto } from '../models/aggregierte-auswertung-spalte-dto';
import { createAggregierteAuswertungLayout$Json } from '../fn/aggregierte-auswertung-layout/create-aggregierte-auswertung-layout-json';
import { CreateAggregierteAuswertungLayout$Json$Params } from '../fn/aggregierte-auswertung-layout/create-aggregierte-auswertung-layout-json';
import { createAggregierteAuswertungLayout$Plain } from '../fn/aggregierte-auswertung-layout/create-aggregierte-auswertung-layout-plain';
import { CreateAggregierteAuswertungLayout$Plain$Params } from '../fn/aggregierte-auswertung-layout/create-aggregierte-auswertung-layout-plain';
import { deleteAggregierteAuswertungLayout } from '../fn/aggregierte-auswertung-layout/delete-aggregierte-auswertung-layout';
import { DeleteAggregierteAuswertungLayout$Params } from '../fn/aggregierte-auswertung-layout/delete-aggregierte-auswertung-layout';
import { getAggregierteAuswertungLayoutById$Json } from '../fn/aggregierte-auswertung-layout/get-aggregierte-auswertung-layout-by-id-json';
import { GetAggregierteAuswertungLayoutById$Json$Params } from '../fn/aggregierte-auswertung-layout/get-aggregierte-auswertung-layout-by-id-json';
import { getAggregierteAuswertungLayoutById$Plain } from '../fn/aggregierte-auswertung-layout/get-aggregierte-auswertung-layout-by-id-plain';
import { GetAggregierteAuswertungLayoutById$Plain$Params } from '../fn/aggregierte-auswertung-layout/get-aggregierte-auswertung-layout-by-id-plain';
import { getAllAggregierteAuswertungLayouts$Json } from '../fn/aggregierte-auswertung-layout/get-all-aggregierte-auswertung-layouts-json';
import { GetAllAggregierteAuswertungLayouts$Json$Params } from '../fn/aggregierte-auswertung-layout/get-all-aggregierte-auswertung-layouts-json';
import { getAllAggregierteAuswertungLayouts$Plain } from '../fn/aggregierte-auswertung-layout/get-all-aggregierte-auswertung-layouts-plain';
import { GetAllAggregierteAuswertungLayouts$Plain$Params } from '../fn/aggregierte-auswertung-layout/get-all-aggregierte-auswertung-layouts-plain';
import { getAllAggregierteAuswertungSpalten$Json } from '../fn/aggregierte-auswertung-layout/get-all-aggregierte-auswertung-spalten-json';
import { GetAllAggregierteAuswertungSpalten$Json$Params } from '../fn/aggregierte-auswertung-layout/get-all-aggregierte-auswertung-spalten-json';
import { getAllAggregierteAuswertungSpalten$Plain } from '../fn/aggregierte-auswertung-layout/get-all-aggregierte-auswertung-spalten-plain';
import { GetAllAggregierteAuswertungSpalten$Plain$Params } from '../fn/aggregierte-auswertung-layout/get-all-aggregierte-auswertung-spalten-plain';
import { updateAggregierteAuswertungLayout$Json } from '../fn/aggregierte-auswertung-layout/update-aggregierte-auswertung-layout-json';
import { UpdateAggregierteAuswertungLayout$Json$Params } from '../fn/aggregierte-auswertung-layout/update-aggregierte-auswertung-layout-json';
import { updateAggregierteAuswertungLayout$Plain } from '../fn/aggregierte-auswertung-layout/update-aggregierte-auswertung-layout-plain';
import { UpdateAggregierteAuswertungLayout$Plain$Params } from '../fn/aggregierte-auswertung-layout/update-aggregierte-auswertung-layout-plain';

@Injectable({ providedIn: 'root' })
export class AggregierteAuswertungLayoutApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllAggregierteAuswertungLayouts()` */
  static readonly GetAllAggregierteAuswertungLayoutsPath = '/v1/aggregierteAuswertung/layouts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAggregierteAuswertungLayouts$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAggregierteAuswertungLayouts$Plain$Response(params?: GetAllAggregierteAuswertungLayouts$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregierteAuswertungLayoutDto>>> {
    return getAllAggregierteAuswertungLayouts$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAggregierteAuswertungLayouts$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAggregierteAuswertungLayouts$Plain(params?: GetAllAggregierteAuswertungLayouts$Plain$Params, context?: HttpContext): Observable<Array<AggregierteAuswertungLayoutDto>> {
    return this.getAllAggregierteAuswertungLayouts$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AggregierteAuswertungLayoutDto>>): Array<AggregierteAuswertungLayoutDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAggregierteAuswertungLayouts$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAggregierteAuswertungLayouts$Json$Response(params?: GetAllAggregierteAuswertungLayouts$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregierteAuswertungLayoutDto>>> {
    return getAllAggregierteAuswertungLayouts$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAggregierteAuswertungLayouts$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAggregierteAuswertungLayouts$Json(params?: GetAllAggregierteAuswertungLayouts$Json$Params, context?: HttpContext): Observable<Array<AggregierteAuswertungLayoutDto>> {
    return this.getAllAggregierteAuswertungLayouts$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AggregierteAuswertungLayoutDto>>): Array<AggregierteAuswertungLayoutDto> => r.body)
    );
  }

  /** Path part for operation `createAggregierteAuswertungLayout()` */
  static readonly CreateAggregierteAuswertungLayoutPath = '/v1/aggregierteAuswertung/layouts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAggregierteAuswertungLayout$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAggregierteAuswertungLayout$Plain$Response(params?: CreateAggregierteAuswertungLayout$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
    return createAggregierteAuswertungLayout$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAggregierteAuswertungLayout$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAggregierteAuswertungLayout$Plain(params?: CreateAggregierteAuswertungLayout$Plain$Params, context?: HttpContext): Observable<AggregierteAuswertungLayoutDto> {
    return this.createAggregierteAuswertungLayout$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AggregierteAuswertungLayoutDto>): AggregierteAuswertungLayoutDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAggregierteAuswertungLayout$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAggregierteAuswertungLayout$Json$Response(params?: CreateAggregierteAuswertungLayout$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
    return createAggregierteAuswertungLayout$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAggregierteAuswertungLayout$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAggregierteAuswertungLayout$Json(params?: CreateAggregierteAuswertungLayout$Json$Params, context?: HttpContext): Observable<AggregierteAuswertungLayoutDto> {
    return this.createAggregierteAuswertungLayout$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AggregierteAuswertungLayoutDto>): AggregierteAuswertungLayoutDto => r.body)
    );
  }

  /** Path part for operation `getAggregierteAuswertungLayoutById()` */
  static readonly GetAggregierteAuswertungLayoutByIdPath = '/v1/aggregierteAuswertung/layouts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAggregierteAuswertungLayoutById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAggregierteAuswertungLayoutById$Plain$Response(params: GetAggregierteAuswertungLayoutById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
    return getAggregierteAuswertungLayoutById$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAggregierteAuswertungLayoutById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAggregierteAuswertungLayoutById$Plain(params: GetAggregierteAuswertungLayoutById$Plain$Params, context?: HttpContext): Observable<AggregierteAuswertungLayoutDto> {
    return this.getAggregierteAuswertungLayoutById$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AggregierteAuswertungLayoutDto>): AggregierteAuswertungLayoutDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAggregierteAuswertungLayoutById$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAggregierteAuswertungLayoutById$Json$Response(params: GetAggregierteAuswertungLayoutById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
    return getAggregierteAuswertungLayoutById$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAggregierteAuswertungLayoutById$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAggregierteAuswertungLayoutById$Json(params: GetAggregierteAuswertungLayoutById$Json$Params, context?: HttpContext): Observable<AggregierteAuswertungLayoutDto> {
    return this.getAggregierteAuswertungLayoutById$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AggregierteAuswertungLayoutDto>): AggregierteAuswertungLayoutDto => r.body)
    );
  }

  /** Path part for operation `updateAggregierteAuswertungLayout()` */
  static readonly UpdateAggregierteAuswertungLayoutPath = '/v1/aggregierteAuswertung/layouts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAggregierteAuswertungLayout$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAggregierteAuswertungLayout$Plain$Response(params: UpdateAggregierteAuswertungLayout$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
    return updateAggregierteAuswertungLayout$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAggregierteAuswertungLayout$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAggregierteAuswertungLayout$Plain(params: UpdateAggregierteAuswertungLayout$Plain$Params, context?: HttpContext): Observable<AggregierteAuswertungLayoutDto> {
    return this.updateAggregierteAuswertungLayout$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AggregierteAuswertungLayoutDto>): AggregierteAuswertungLayoutDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAggregierteAuswertungLayout$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAggregierteAuswertungLayout$Json$Response(params: UpdateAggregierteAuswertungLayout$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
    return updateAggregierteAuswertungLayout$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAggregierteAuswertungLayout$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAggregierteAuswertungLayout$Json(params: UpdateAggregierteAuswertungLayout$Json$Params, context?: HttpContext): Observable<AggregierteAuswertungLayoutDto> {
    return this.updateAggregierteAuswertungLayout$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AggregierteAuswertungLayoutDto>): AggregierteAuswertungLayoutDto => r.body)
    );
  }

  /** Path part for operation `deleteAggregierteAuswertungLayout()` */
  static readonly DeleteAggregierteAuswertungLayoutPath = '/v1/aggregierteAuswertung/layouts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAggregierteAuswertungLayout()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAggregierteAuswertungLayout$Response(params: DeleteAggregierteAuswertungLayout$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAggregierteAuswertungLayout(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAggregierteAuswertungLayout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAggregierteAuswertungLayout(params: DeleteAggregierteAuswertungLayout$Params, context?: HttpContext): Observable<void> {
    return this.deleteAggregierteAuswertungLayout$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllAggregierteAuswertungSpalten()` */
  static readonly GetAllAggregierteAuswertungSpaltenPath = '/v1/aggregierteAuswertung/layouts/spalten';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAggregierteAuswertungSpalten$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAggregierteAuswertungSpalten$Plain$Response(params?: GetAllAggregierteAuswertungSpalten$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregierteAuswertungSpalteDto>>> {
    return getAllAggregierteAuswertungSpalten$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAggregierteAuswertungSpalten$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAggregierteAuswertungSpalten$Plain(params?: GetAllAggregierteAuswertungSpalten$Plain$Params, context?: HttpContext): Observable<Array<AggregierteAuswertungSpalteDto>> {
    return this.getAllAggregierteAuswertungSpalten$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AggregierteAuswertungSpalteDto>>): Array<AggregierteAuswertungSpalteDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAggregierteAuswertungSpalten$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAggregierteAuswertungSpalten$Json$Response(params?: GetAllAggregierteAuswertungSpalten$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregierteAuswertungSpalteDto>>> {
    return getAllAggregierteAuswertungSpalten$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAggregierteAuswertungSpalten$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAggregierteAuswertungSpalten$Json(params?: GetAllAggregierteAuswertungSpalten$Json$Params, context?: HttpContext): Observable<Array<AggregierteAuswertungSpalteDto>> {
    return this.getAllAggregierteAuswertungSpalten$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AggregierteAuswertungSpalteDto>>): Array<AggregierteAuswertungSpalteDto> => r.body)
    );
  }

}
